// extracted by mini-css-extract-plugin
export default {"container":"Op-z","brandName":"Pp-z","productName":"Qp-z","productNamePdpEnhancements":"Rp-z","breakLongProductName":"Sp-z"};